// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1aYix","balanceDisclaimer":"posDashboard_balanceDisclaimer__1xBKo"};